var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-error"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.$t('headline_copy'))}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('body_copy'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }